import { Component, OnInit } from '@angular/core';
import { AccessUserInfo, UserDetail, UserLocationFacility } from 'src/app/models';
import { CustomDatePipe } from 'src/app/pipes';
import { CustomDialogService, FacilityService, UserService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';
import { DatePipe } from '@angular/common';
import { SelectItem } from 'primeng';
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';

@Component({
  selector: 'bart-lab-results',
  templateUrl: './lab-results.component.html',
  styleUrls: ['./lab-results.component.scss'],
  providers : [ CustomDialogService,CustomDatePipe,DatePipe]
})
export class LabResultsComponent implements OnInit {
 
  facilityList: SelectItem[] = [];
  userLocationFacilities: UserLocationFacility[] = [];
  public userInfo: UserDetail;
  selectedFacilityMasterId?: number = null;
  isFromLabResultPage = true;
  constructor
  (  
    public dialogService: CustomDialogService,
    private _facilityService: FacilityService,
    private _loaderService: LoaderService,
    private _userService:UserService
  ) 
  {
    this.userInfo = AccessUserInfo.getUserInfo();
    this.selectedFacilityMasterId= AccessUserInfo.getSelectedFacilityMasterId()
  }
  ngOnInit() {
    this.GetUserLocations();
  }
  private GetUserLocations() {
    this._loaderService.show();
    this.facilityList = [];
    let getLocationParam =
    {
      "GETUSERLOCATIONS":
      {
        LOCATION_ID_LIST: null,
        USERNAME: this.userInfo.userName,
      },
      "GETUSERLOCATIONS2":
      {
        USERNAME: this.userInfo.userName,
      }
    }
    if (getLocationParam != null) {
      this._facilityService.getUserLocations(JSON.stringify(getLocationParam))
        .subscribe((resp: any) => {
          if (resp.facilities) {
            this.userLocationFacilities=resp.facilities
            this.facilityList = this.userLocationFacilities.filter(x=>x.LocationModality && x.LocationModality.length>0).map(data => ({
              label: data.FacilityDisplayName,
              value: data.FacilityMasterID,
            }));
            if (this.facilityList && this.facilityList.length &&  this.selectedFacilityMasterId==null) {
              this.selectedFacilityMasterId = this.facilityList[0].value;
            }
            this._loaderService.hide();
          }
          else {
            this._loaderService.hide();
          }

        },
          (error) => {
            this._loaderService.hide();
            this.facilityList = [];
          });
    }
  }
  FacilityDropdownChanged()
  {
   
  }
}








